import React from "react";
import styles from "./Slide1.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../../Preparations.messages";
import * as appConfig from "appConfig";

export const Slide1: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.slide1}>
      <h2 className={styles.title}>{formatMessage(messages.softwareRequirementsSlide1Title)}</h2>
      <div className={styles.content}>
        <p>{formatMessage(messages.softwareRequirementsSlide1Description1)}</p>
        <div className={styles.imageContainer}>
          <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/6.png`} />
        </div>
        <p>{formatMessage(messages.softwareRequirementsSlide1Description2)}</p>
      </div>
    </div>
  );
};
